import { Config } from '@backstage/config';
import {
  configApiRef,
  microsoftAuthApiRef,
  githubAuthApiRef,
  useApi,
  SignInPageProps
}
from '@backstage/core-plugin-api';
import { SignInPage, SignInProviderConfig } from '@backstage/core-components';

export type PlattSignInPageProps = SignInPageProps & {
  auto?: boolean
};

const providerApiRef = (providerType?: string) => {
  switch (providerType) {
    case 'microsoft':
      return microsoftAuthApiRef;
    case 'github':
    default:
      return githubAuthApiRef;
  }
};

export const signInProviderConfig = (config: Config): SignInProviderConfig => ({
  id: 'platt-signin-provider',
  title: config.getOptionalString('auth.plattSignInTitle') ?? 'Platt Backstage',
  message: config.getOptionalString('auth.plattSignInMessage') ?? 'Sign in with SSO',
  apiRef: providerApiRef(config.getOptionalString('auth.plattSignInProvider'))
});

export function PlattSignInPage(props: PlattSignInPageProps) {

  const backstageConfig = useApi(configApiRef);
  return (<SignInPage
    {...props}
    provider={signInProviderConfig(backstageConfig)}
  />);
};
